<div
    class="cerrix-toggle-card"
    role="button"
    [class.selected]="selected()"
    [attr.aria-pressed]="selected()"
    [attr.aria-label]="ariaLabel() || null"
    [attr.tabindex]="0"
    (click)="onClickHandler()"
>
    <ng-content></ng-content>
</div>
